/* eslint-disable max-len */
import React from 'react';
import styled from 'styled-components';
import {useSelector} from 'react-redux';
import {useTranslation} from 'react-i18next';

import {
    mobileMediaQuery,
    tabletMediaQuery,
    notWebMediaQuery,
    webMediaQuery,
} from '../../styles';

import Carousel from '../Carousel';
import GamesCarousel from '../GamesCarousel';
import {getCurrentLang} from '../../utils/i18n';

const CustomLayout = styled.div`
    width: ${props => (props.width ? props.width : '100%')};
    margin: ${props => (props.margin ? props.margin : '0px')};
    padding: ${props => (props.padding ? props.padding : '0px')};

    ${webMediaQuery} {
        padding: 0px 40px !important;
        box-sizing: border-box;

        :not(:last-of-type) {
            margin-bottom: 50px;
        }
    }

    ${tabletMediaQuery} {
        padding-left: 24px;
        margin-bottom: 40px;
    }

    ${mobileMediaQuery} {
        margin-bottom: 36px;
    }

    ${notWebMediaQuery} {
        padding-left: 0px;
    }

    .carousel-container {
        ${notWebMediaQuery} {
            margin-left: 40px;
        }

        ${mobileMediaQuery} {
            margin-left: 25px;
        }
    }
`;

const Title = styled.h2`
    font-size: 20px;
    line-height: 20px;
    text-transform: uppercase;
    text-align: ${props => (props.titleAlign ? props.titleAlign : 'center')};

    margin-top: 0px;
    margin-bottom: 8px;

    ${tabletMediaQuery} {
        margin-left: 40px;
    }

    ${mobileMediaQuery} {
        font-size: 18px;
        line-height: 18px;

        margin-bottom: 10px;
        margin-left: 25px;
    }
`;

const ContentRow = ({
    title,
    titleAlign,
    titleAs,
    items,
    padding,
    margin,
    width,
    onClickContent,
    sendEvents,
    type,
    ...props
}) => {
    const {t} = useTranslation();
    const user = useSelector(state => state.user);
    const idp = user && user.idp;

    const sendAnalyticsEvent = (...args) => {
        let action = args[0] || null;
        let show = args[1]?.show?.title || null;

        if (action === 'previous') {
            action = 'Previous Arrow';
        } else if (action === 'next') {
            action = 'Next Arrow';
        } else {
            action = 'Show Click';
        }

        if (args[1]?.show) {
            onClickContent(...args);

            action = t('video.titleFormat')
                .replace('{season}', args[1].season)
                .replace('{episode}', args[1].episode);
        }

        window.turner_metadata.trackAction.push({
            type: 'pageview',
            data: {
                pageName: 'cnplus.com/home',
                section: 'Home',
                subsection: 'nvs',
                mvpd: idp || 'idp not loaded',
                userlang: getCurrentLang(),
                domain: 'cnplus.com',
                region: 'latam',
                country:
                    user && user.countryIsoCode && user.countryName
                        ? `${user.countryIsoCode.toLowerCase()}|${
                              user.countryName
                          }`
                        : 'not loaded',
                brand: 'cartoon network',
                franchise: show,
                contenttype: 'Content Row',
                contenttitle: action || 'ContentRow',
                platform: 'web',
                interaction: show
                    ? `content row click|${title}`
                    : `content arrow click|${title}`,

                interactionevent: 1,
            },
        });
    };

    return (
        <CustomLayout
            width={width}
            margin={margin}
            padding={padding}
            className={props.className}
        >
            {title !== undefined && (
                <Title as={titleAs} titleAlign={titleAlign}>
                    {title}
                </Title>
            )}

            {type === 'games' ? (
                <GamesCarousel
                    className="slider-frame"
                    items={items}
                    handleClickContent={onClickContent}
                />
            ) : (
                <Carousel
                    className="slider-frame"
                    items={items}
                    handleClickContent={
                        sendEvents ? sendAnalyticsEvent : onClickContent
                    }
                    handleClickArrow={sendEvents && sendAnalyticsEvent}
                    vods
                />
            )}
        </CustomLayout>
    );
};

export default ContentRow;
